import { useState, useRef, useEffect } from "react";
import {
    Box, Button, ButtonGroup, Card, CardContent, 
    Grid2 as Grid,
    Tooltip,
    Typography,
} from '@mui/material';
import { Checklist, EmojiEvents, PlayArrow, Stop } from '@mui/icons-material';
import { checkComponentPresence, myTimestampToDate, propComparatorDateTime } from "../utils/ui_utils";

import { format } from "date-fns";
import { get_Match_list } from "../FirebaseUtils/dbMatch";
import { globalstyles } from "../lib/definitions";
import { CowSublistDialog } from "../modals/CowSublistDialog";
import { get_event_status_live  } from "../FirebaseUtils/dbEvent";
import { useEvent } from "../context/eventContext";
import { AwardListDialog } from "../modals/AwardListDialog";
import { AwardListPointDialog } from "../modals/AwardListPointDialog";



export const PublicMatchPage = () => {
    const resultRef = useRef()
    const cowlistRef = useRef()

    const cow_list = []

    const { selEvent } = useEvent()
    const [event_status, setEventStatus] = useState({})

    const [element_list, setElementList] = useState([])

    const showCowlist = (dyn, cat, index) => {
        cowlistRef.current.onOpen(cat.cow_list, { ...cat, title: cat.match_name + " " + cat.match_description, lock: true }, index)
    }

    const handleShowMatch = (cat, index) => {
        resultRef.current.onEdit({ ...cat, result_list: cat.result_list }, index)
    }



    const reloadFn = async (el) => {
        if (el) {
            setElementList(lst => {
                const c = checkComponentPresence(el, element_list, 'id')
                let _el = [...lst]
                if (c >= 0) {
                    _el.splice(c, 1, el)
                } else {

                }
                return _el
            })


        } else {
            const data = await get_Match_list(selEvent.id)
            setElementList(data.sort(propComparatorDateTime('planned_start')))
        }
    }





    useEffect(() => {
        reloadFn()
        document.title = 'ShowTime ANAFIBJ - gestione gare';
        let unsubscribe = () => {

        }

        const ev_callback = (cur_session) => {
            console.log("CUR SESSION", cur_session)
            unsubscribe = setEventStatus(cur_session)
        }
        const initLive = async () => {
            if (selEvent.id) {
                const cs = await get_event_status_live(selEvent.id, ev_callback)
            }
        }
        initLive()
        return () => {
            try {
                unsubscribe()
            } catch (err) {

            }
        }

    }, [selEvent])

    return (
        <Box sx={{ textAlign: 'center', p: 1 }}>

            <AwardListPointDialog ref={resultRef} element_list={element_list} cow_list={cow_list} is_public />
            <CowSublistDialog ref={cowlistRef} element_list={element_list} match/>
            <Card sx={{ border: '1px solid lightblue' }}>
                <CardContent>
                    <Grid container spacing={2} sx={{ background: 'lightblue', p: 0.5, borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                        <Grid size={"grow"} sx={{ fontSize: '1.2em', fontWeight: 'bold' }}>
                            Lista gare
                        </Grid>
                    </Grid>
                    <Grid container sx={{ backgroundColor: 'lightgrey' }}>
                        <Grid size="grow">
                            nome
                            <Box style={{ fontSize: '0.7em' }}>descrizione</Box>
                        </Grid>
                        <Grid size="grow">
                            ora inizio previsto
                        </Grid>
                        <Grid size={1}>
                            risultati
                        </Grid>
                    </Grid>

                    <Grid >
                        {element_list.filter(s => s.is_public).map((s, k) => (
                            <OneMatch
                                is_current={event_status?.cur_match?.id === s.id}
                                key={k}
                                match={s}
                                index={k}
                                handleShowList={(dyn) => showCowlist(dyn, s, k)}
                                handleShowMatch={() => handleShowMatch(s, k)}
                            />
                        ))}
                    </Grid>
                </CardContent>
            </Card>
        </Box >
    );

}


const OneMatch = ({ match, index, is_current, handleShowList, handleShowMatch }) => {

    let matchIcon = <></>
    let matchstatus = ''
    if (match.status === 'pre') {
        matchIcon = <Checklist />
        matchstatus = ' (controllo presenze)'
    } else if (match.status === 'run') {
        matchIcon = <PlayArrow />
        matchstatus = ' (gara in corso)'
    } else if (match.status === 'end') {
        matchIcon = <Stop />
        matchstatus = ' (gara terminata)'
    }



    return (
        <Grid container sx={globalstyles.list_row}>

            <Grid size={"grow"} container flexDirection={"column"}>
                <Grid size={"grow"} sx={{ fontWeight: 'bold' }}>
                    {match.match_name}
                </Grid>
                <Grid size={"grow"} sx={{ fontSize: '0.8em' }}>
                    {match.match_description}
                </Grid>
            </Grid>
            <Grid size={"grow"}>
                {is_current  &&
                    <Tooltip title={"gara in corso"}>
                        <PlayArrow color={"success"} />
                    </Tooltip>
                }
                <Typography sx={{ fontSize: '0.7em' }} as="span">
                    {format(myTimestampToDate(match.planned_start), 'dd/MM')}&nbsp;
                </Typography>
                {format(myTimestampToDate(match.planned_start), 'HH:mm')}
            </Grid>
            <Grid size={1}>
                <ButtonGroup>
                    <Button color="secondary" variant="outlined" onClick={() => handleShowList()} size="small">
                        {match.cow_list?.length}
                    </Button>
                <Button variant="outlined" disabled={!match.status} size="small" color={is_current ? 'success' : 'primary'} onClick={() => handleShowMatch(match, index)} startIcon={<EmojiEvents />} endIcon={matchIcon}></Button>
                </ButtonGroup>

            </Grid>
        </Grid>

    )
}


